import React from "react";
import Author from "../author";

import Contact from "../contact";
import Cta from "../cta";
import Footer from "../global/footer";
import Header from "../global/header";
import Herov2 from "../herov2";
import Books from "../books_other";

const VersionMain = ({ header, footer }) => {
  const { menu } = footer;
  return (
    <>
      <Header header={header} />
      <Herov2 isBg="yes" />
      <Cta isBg="" />
      <Books isBg="yes" />
      <Author isBg="" />
      <Contact isBg="yes" />
      <Footer isBg="yes" menu={menu} />
    </>
  );
};

export default VersionMain;
